export default __webpack_public_path__ + "static/o_firmie-3d1a74e6db89d83de09a50650c41af5f.jpg";